export function effectiveMinimumWithdrawal(configuredAmount) {
  // $20 is only the fallback for absent/invalid rules, never a team override.
  if (configuredAmount == null || configuredAmount === '') return 20;
  const amount = Number(configuredAmount);
  return Number.isFinite(amount) && amount >= 0 ? amount : 20;
}

export function calculateExpressCashoutBreakdown({ grossAmount, tipAmount = 0, feePercent = 0, express = false }) {
  const gross = Math.max(Number(grossAmount) || 0, 0);
  const tip = Math.max(Number(tipAmount) || 0, 0);
  const amountAfterTip = Math.max(Math.round((gross - tip) * 100) / 100, 0);
  const percent = express ? Math.min(Math.max(Number(feePercent) || 0, 0), 100) : 0;
  const fee = express ? Math.round((amountAfterTip * percent / 100) * 100) / 100 : 0;
  return {
    amountAfterTip,
    feePercent: percent,
    feeAmount: fee,
    payoutAmount: Math.max(Math.round((amountAfterTip - fee) * 100) / 100, 0),
  };
}
